import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../modal/withModal';
import GDPRFaceRecognitionConsent from './GDPRFaceRecognitionConsent';

export const GDPR_FACE_RECOGNITION_CONSENT_MODAL =
  'MODAL/GDPR_FACE_RECOGNITION_CONSENT';

const propTypes = {
  onRequestClose: PropTypes.func,
  actionProps: PropTypes.shape({
    albumFolder: PropTypes.shape({
      id: PropTypes.string,
      is_web_gallery: PropTypes.bool,
    }),
  }),
};

const GDPRFaceRecognitionConsentModal = ({
  onRequestClose,
  actionProps = {},
  ...props
}) => {
  const { albumFolder } = actionProps;
  return (
    <GDPRFaceRecognitionConsent
      onClose={onRequestClose}
      albumFolder={albumFolder}
      {...props}
    />
  );
};

GDPRFaceRecognitionConsentModal.propTypes = propTypes;

export default withModal(GDPRFaceRecognitionConsentModal, {
  name: GDPR_FACE_RECOGNITION_CONSENT_MODAL,
  size: 'sm',
  type: 'full',
  dismissible: false,
  shouldCloseOnOverlayClick: false,
});
